import './settings-leaf.css';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../ui.tsx';
import { CardSaveFooter, useCompanyCardForm } from './company-card-form.tsx';
import type { Company } from '@shared/types/index.ts';

/**
 * The tips switch. A company setting rather than a processor one — recording
 * a cash tip needs no payment account — so it saves through the company
 * record like the pricing card, not through the payment-settings PATCH.
 * Per-location overrides live with the rest of them, in Locations.
 */

const snapshot = (company: Company) => ({
  tipsEnabled: company.tipsEnabled,
});

const toPayload = (draft: ReturnType<typeof snapshot>) => ({
  tipsEnabled: draft.tipsEnabled,
});

export default function TipsCard() {
  const { t } = useTranslation();
  const form = useCompanyCardForm(snapshot, toPayload);

  const draft = form.draft;
  if (!draft) return null;

  return (
    <section className="card work-section settings-leaf mb-6" aria-labelledby="tips-heading">
      <div className="work-section-heading">
        <h2 id="tips-heading" className="mb-2 text-lg font-semibold">
          {t('settings.tipsHeading')}
        </h2>
      </div>
      <p className="mb-4 text-sm text-[color:var(--color-muted)]">{t('settings.tipsDescription')}</p>

      <Checkbox
        label={t('settings.tipsEnable')}
        hint={t('settings.tipsEnableHint')}
        checked={draft.tipsEnabled}
        disabled={form.readOnly}
        onChange={(event) => form.set('tipsEnabled', event.target.checked)}
      />

      <CardSaveFooter form={form} saveLabel={t('settings.saveTips')} />
    </section>
  );
}
